import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import classNames from "classnames";
import dayjs from "dayjs";

import { CCard, CCardBody, CCardHeader } from "@coreui/react";

import { deXuatNhaCungCapApi } from "src/1/apis/de_xuat_nha_cung_cap.api";
import { useSetQueryData } from "src/1/hooks/query";
import { history, warningDelete } from "src/App";
import { useMobileDevice } from "src/utils/hooks/viewport";

import { SuggestListTable, SuggestListToolbar } from "../../components";

const DanhSachDeXuatNhaCungCap = () => {
  //#region Data
  const [params, setParams] = useState({
    cycle: "",
    year: dayjs().year(),
    start_at: dayjs().set("date", 1).toDate(),
    end_at: dayjs().endOf("month").toDate(),
  });

  const { data, refetch, isFetching } = useQuery({
    queryKey: ["danh-sach-de-xuat-nha-cung-cap", params],
    queryFn: () => deXuatNhaCungCapApi.getAll(params),
    select: (response) =>
      Array.isArray(response) ? response : response?.data?.data,
  });

  const { setQueryData } = useSetQueryData([
    "danh-sach-de-xuat-nha-cung-cap",
    params,
  ]);

  const isSelectAll = useMemo(() => data?.every((e) => e.check), [data]);

  const selected = useMemo(() => data?.filter((e) => e.check) ?? [], [data]);

  const isMobile = useMobileDevice();
  //#endregion

  //#region Event
  const onSelect = (code, value) => {
    setQueryData(
      data?.map((e) =>
        code === -1 || e.code === code ? { ...e, check: value } : e,
      ),
    );
  };

  const onSearch = (_params) => setParams(_params);

  const onAdd = () => history.push("/supplier-suggest/form");

  const onEdit = () => {
    const id = data.find((e) => e.check)?.id;
    history.push(`/supplier-suggest/form/${id}`);
  };

  const onRemove = () => {
    warningDelete({
      onConfirm: () => deXuatNhaCungCapApi.remove(selected?.[0]?.id),
      onSuccess: () => {
        refetch();
        return "Xóa thành công";
      },
      onError: (error) =>
        error?.message || "Xóa đề xuất nhà cung cấp không thành công!",
    });
  };
  //#endregion

  //#region Render
  return (
    <>
      <CCard className={classNames("toolbar", !isMobile && "sticky")}>
        <CCardBody>
          <SuggestListToolbar
            params={params}
            canAdd
            canEdit={selected?.length === 1}
            canRemove={selected?.length === 1}
            onAdd={onAdd}
            onEdit={onEdit}
            onRemove={onRemove}
            onSearch={onSearch}
          />
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader></CCardHeader>
        <CCardBody className="px-0 pt-0">
          <SuggestListTable
            loading={isFetching}
            isSelectAll={isSelectAll}
            data={data}
            onSelect={onSelect}
          />
        </CCardBody>
      </CCard>
    </>
  );
  //#endregion
};
export default DanhSachDeXuatNhaCungCap;
